<abp-loader-bar></abp-loader-bar>
<abp-dynamic-layout></abp-dynamic-layout>

<nexweb-session-expiry-dialog></nexweb-session-expiry-dialog>
<!--Div to append dynamic windows-->
<div kendoDialogContainer></div>
<nexweb-loading-panel></nexweb-loading-panel>
